import * as React from "react";
import { Component } from "react";

import EmptyResults from "components/EmptyResults";
import { Nullable, TransactionType } from "types";
import { formatMoney } from "accounting";
import { getClasses } from "utils";

interface PropsTypes {
  header: string;
  transactions: TransactionType[];
  onEmpty: string;
  type: string;
  visible: boolean;
}

class TransactionsTable extends Component<PropsTypes> {
  Body = (): JSX.Element => {
    const { onEmpty, transactions } = this.props;

    if (!transactions.length) return <EmptyResults message={onEmpty} />;

    const Rows = transactions.map((transaction, idx) => {
      const {
        amount,
        caseNumber,
        creditor,
        date,
        id,
        tfsFees,
        amountWithFees,
      } = transaction;

      const key = `${id}+${idx}`;

      return (
        <tr key={key}>
          <td>{date}</td>
          <td>{caseNumber}</td>
          <td>{creditor}</td>
          <td>{formatMoney(amount)}</td>
          <td>{formatMoney(tfsFees)}</td>
          <td>{formatMoney(amountWithFees)}</td>
        </tr>
      );
    });

    return (
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Case Number</th>
              <th>Payee</th>
              <th>Amount</th>
              <th>Tech Fee</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>{Rows}</tbody>
        </table>
      </div>
    );
  };

  Header = (): Nullable<JSX.Element> => {
    const { header } = this.props;

    if (!header) return null;

    return (
      <h2>
        <div className="badge">
          <i className="fas fa-exchange-alt" />
        </div>
        <strong>{header}</strong>
      </h2>
    );
  };

  render(): JSX.Element {
    const {
      Body,
      Header,
      props: { type },
    } = this;

    return (
      <div className={getClasses("tfs--transactions", { [type]: !!type })}>
        <Header />
        <Body />
      </div>
    );
  }
}

export default function TransactionsTableWrapper(
  props: PropsTypes,
): JSX.Element {
  const defaultProps = { visible: true };
  const { visible } = { ...defaultProps, ...props };

  return visible && <TransactionsTable {...props} />;
}
